import React from "react";

type StaticDashboardContainerProps = {
  heading: string;
  children: React.ReactNode;
};

const StaticDashboardContainer = ({ heading, children }: StaticDashboardContainerProps) => {
  return (
    <div className="h-[93%] p-4 flex flex-col gap-4 overflow-hidden">
      <h1 className="font-semibold text-lg 2xl:text-3xl flex-shrink-0">{heading}</h1>
      <div className="flex-1 min-h-0 w-full overflow-hidden">
        {children}
      </div>
    </div>
  );
};

export default StaticDashboardContainer;